import './lib/polyfills'
import { loadableReady } from '@loadable/component'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import { hydrate } from 'react-dom'
import { BrowserRouter } from 'react-router-dom'

import { AppInitialProps } from './@types'
import { App } from './App'
import { RuntimeConfigs, StaticConfigs } from './config'
import { APP_DATA_KEY, APP_ROOT_ELEMENT_ID } from './constants/app.constants'

Sentry.init({
  dsn: RuntimeConfigs.SENTRY_DSN,
  environment: RuntimeConfigs.RELEASE_CHANNEL,
  integrations: [new BrowserTracing()],
  tracesSampler: samplingContext => {
    if (samplingContext.transactionContext.name === 'ChunkLoadError') {
      return 0
    }
    return 0.3
  },
  release: `web-app@${StaticConfigs.APP_VERSION}`,
  enabled: StaticConfigs.IS_PROD,
})

const appDataScript = document.getElementById(APP_DATA_KEY)
let appData
try {
  appData = JSON.parse(appDataScript.innerHTML)
  appDataScript.remove()
} catch (e) {
  appData = {}
}

const authToken: AppInitialProps['authToken'] = appData?.appProps?.authToken
Sentry.setTag('user.networkId', authToken?.networkPublicInfo?.id || '')
Sentry.setTag('user.networkName', authToken?.networkPublicInfo?.name || '')
Sentry.setTag('user.networkDomain', authToken?.networkPublicInfo?.domain || '')
Sentry.setTag('user.roleType', authToken?.member?.role?.type || '')
Sentry.setTag('user.status', authToken?.member?.status || '')
Sentry.setUser({
  email: authToken?.member?.email,
  id: authToken?.member?.id,
  username: authToken?.member?.username,
})

// Load all components needed before rendering
loadableReady().then(() => {
  const pageProps = appData?.appProps || {}
  hydrate(
    <BrowserRouter>
      <App pageProps={pageProps} apiUrl={RuntimeConfigs.TRIBE_GQL_ENDPOINT} />
    </BrowserRouter>,
    document.getElementById(APP_ROOT_ELEMENT_ID),
  )
})

if (module.hot) {
  module.hot.accept()
}
